
import HeaderTop from '../../header';
import { Header } from '../components/header';
import { ManagementSection } from "../components/management-section";
import ReportsDashboard from '../components/reports/reports';
import { Container} from "react-bootstrap"


const Reports = () => {
    return (
       <div>
         <HeaderTop isHiddenMainMenu/>
        <div className="min-vh-100 bg-white">
        <Header heading="Reports" bg="linear-gradient(90deg, #255A71 0%, #0096D7 100%)"  color="white" outline="outline-white-button"/>
        <ManagementSection />
        <section className="px-5">
        <Container>
        
          <ReportsDashboard />
          </Container>
        </section>
        </div>
       </div>
       
    );
};

export default Reports;